import type { SiteAdapter, AdapterContext } from "../adapters/base.js";
import type { ChapterRef, Chapter } from "../data-model/novel.js";
import type { EventBus } from "../core/events.js";
import { ChapterSchema } from "../data-model/schema.js";
import { DownloadError, ParseError } from "../core/errors.js";

export async function fetchChapterTask(
  adapter: SiteAdapter,
  ref: ChapterRef,
  ctx: AdapterContext,
  bus: EventBus,
): Promise<Chapter> {
  bus.emit({ type: "chapter:start", ref });
  let raw: Chapter;
  try {
    raw = await adapter.fetchChapter(ref, ctx);
  } catch (cause) {
    if (cause instanceof DownloadError) throw cause;
    throw new ParseError(`fetchChapter failed for ${ref.url}`, { cause, url: ref.url });
  }
  const parsed = ChapterSchema.safeParse(raw);
  if (!parsed.success) {
    throw new ParseError(`Invalid Chapter from adapter`, { cause: parsed.error, url: ref.url });
  }
  return parsed.data;
}
